<template>
  <v-badge :content="badgeContent" :value="badgeContent > 0" color="marca-0-l40">
    <v-menu ref="menu" v-model="menu" transition="scale-transition" width="260" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field :class="`select-filter-${variant}`" dense :value="label" outlined hide-details readonly v-bind="attrs" v-on="on" @click="menu = true">
          <template #append>
            <mf-icon class="cursor-pointer" color="marca-0-l10" icon="keyboard_arrow_down" @click="menu = true" />
          </template>
        </v-text-field>
      </template>

      <v-card>
        <v-card-text>
          <div v-for="item in values" :key="item.value">
            <v-checkbox
              v-model="selectedOptions"
              hide-details
              :label="item.label"
              :value="item.value"
              :multiple="multiple"
              class="pb-2 ma-0"
              @change="$emit(multiple ? 'change' : 'input', $event)"
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </v-badge>
</template>

<script>
export default {
  name: 'SelectFilter',
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        [
          'club',
          'personType',
          'period',
          'coupon',
          'channels',
          'noProducts',
          'fidelity',
          'ageRange',
          'gender',
          'modality',
          'format',
          'refundStatus',
          'target',
        ].includes(value),
    },
    value: {
      type: [Array, String, Boolean, Number],
      default: () => [],
    },
    multiple: {
      type: Boolean,
      defaukt: false,
    },
    handleDefaultValue: {
      type: Boolean,
      defaukt: false,
    },
  },
  data: () => ({
    menu: false,
    badgeContent: 0,
  }),
  computed: {
    selectedOptions: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    values() {
      const items = {
        club: [
          { label: 'Sim', value: '1' },
          { label: 'Não', value: '0' },
        ],
        personType: [
          { label: 'Física', value: 'F' },
          { label: 'Jurídica', value: 'J' },
        ],
        period: [
          { label: 'Mensal', value: 'Mensal' },
          { label: 'Anual', value: 'Anual' },
        ],
        coupon: [
          { label: 'Recuperado', value: 'RECOVERED' },
          { label: 'Não recuperado', value: 'NOT_RECOVERED' },
          { label: 'Ainda não gerado', value: 'NOT_PROCESSED' },
        ],
        noProducts: [
          { label: 'Campanhas com produtos', value: false },
          { label: 'Campanhas sem produtos', value: true },
        ],
        fidelity: [
          { label: 'Fidelidade', value: 1 },
          { label: 'Não fidelidade', value: 0 },
        ],
        gender: [
          { label: 'Feminino', value: 'F' },
          { label: 'Masculino', value: 'M' },
          { label: 'Indefinido/Outro', value: ' ' },
        ],
        ageRange: [
          { label: 'Todos', value: '' },
          { label: '17 anos ou menos', value: '7' },
          { label: '18 a 24 anos', value: '1' },
          { label: '25 a 34 anos', value: '2' },
          { label: '35 a 44 anos', value: '3' },
          { label: '45 a 54 anos', value: '4' },
          { label: '55 a 64 anos', value: '5' },
          { label: '65 anos ou mais', value: '6' },
          { label: 'Pessoas jurídicas', value: '8' },
          { label: 'Indefinido/outros', value: '0' },
        ],
        refundStatus: [
          { label: 'Em apuração', value: 'counting' },
          { label: 'Apuração concluída', value: 'counted' },
        ],
        modality: [
          { label: 'Mercapromo', value: 'mercapromo' },
          { label: 'Mercatrade', value: 'mercatrade' },
        ],
        format: [
          { label: 'Desconto absoluto', value: 'general' },
          { label: 'Leve e pague', value: 'takepay' },
          { label: 'Cashback', value: 'nextbuycashback' },
          { label: 'Compre e ganhe', value: 'dynamic_rule' },
        ],
        target: [
          { label: 'Massivo', value: 'massive' },
          { label: 'Clube', value: 'club' },
          { label: 'Personalizado', value: 'personalized' },
        ],
        channels: this.allowedChannels,
      }
      return items[this.variant]
    },
    label() {
      const labels = {
        club: 'Clube',
        personType: 'Tipo de pessoa',
        period: 'Período',
        coupon: 'Cupom',
        channels: 'Canais',
        fidelity: 'Fidelidade',
        ageRange: 'Faixa etária',
        gender: 'Gênero',
        noProducts: 'Sem produtos',
        refundStatus: 'Status do reembolso',
        modality: 'Modalidade',
        format: 'Formato',
        target: 'Público alvo',
      }

      return labels[this.variant] || ''
    },
    allowedChannels() {
      const channels = [
        {
          label: 'WhatsApp',
          value: 'WHATSAPP',
          permissionName: 'campanhas/whatsapp',
          moduleName: 'whatsapp',
        },
        {
          label: 'SMS',
          value: 'SMS',
          permissionName: 'campanhas/sms',
        },
        {
          label: 'Aplicativo',
          value: 'PUSH',
          permissionName: 'campanhas/aplicativo',
          moduleName: 'push',
        },
        {
          label: 'E-mail',
          value: 'EMAIL',
          permissionName: 'campanhas/email-v2',
          moduleName: 'email_v2',
        },
      ]

      return channels.filter((channel) => this.checkPageAndModulePermission(channel.permissionName, channel?.moduleName))
    },
    allowedChannelsValues() {
      return this.allowedChannels.map((channel) => channel.value)
    },
  },
  watch: {
    selectedOptions(newVal) {
      if (typeof newVal === 'string') {
        this.badgeContent = newVal ? 1 : 0
      } else {
        this.badgeContent = newVal ? newVal.length : 0
      }
    },
  },
  mounted() {
    if (this.handleDefaultValue) {
      this.selectedOptions = this.getDefaultValue(this.variant)
    }
  },
  methods: {
    checkPageAndModulePermission(pageName, moduleName) {
      const havePagePermission = this.$permissions.havePagePermission(pageName)

      if (moduleName) {
        const haveModulePermission = this.$getAllowedModules()[moduleName]
        return havePagePermission && haveModulePermission
      }

      return havePagePermission
    },
    getDefaultValue(key) {
      const items = {
        period: 'Mensal',
        coupon: ['RECOVERED', 'NOT_RECOVERED', 'NOT_PROCESSED'],
        ageRange: '',
        channels: ['EMAIL', 'PUSH', 'SMS', 'WHATSAPP'],
        refundStatus: ['counting', 'counted'],
        modality: ['mercapromo', 'mercatrade'],
        format: ['general', 'takepay', 'nextbuycashback', 'dynamic_rule'],
        target: ['massive', 'club', 'personalized'],
      }
      return items[key]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-badge__badge {
  margin-left: -8px;
  margin-bottom: -6px;
}
::v-deep .v-text-field {
  font-size: 14px;
}

::v-deep .select-filter-clube,
::v-deep .select-filter-coupon {
  width: 116px;
}
::v-deep .select-filter-channels {
  width: 116px;
}
::v-deep .select-filter-pessoa {
  width: 150px;
}

.select-filter-periodo {
  ::v-deep .v-text-field {
    width: 116px;
  }

  ::v-deep .v-select__selection,
  ::v-deep i {
    color: $marca-0-l10;
  }
}
.select-filter-noProducts {
  ::v-deep .v-text-field {
    width: 230px;
  }

  ::v-deep .v-select__selection,
  ::v-deep i {
    color: $marca-0-l10;
  }
}

::v-deep fieldset {
  border-color: $marca-0-l10;
}

::v-deep input {
  color: $marca-0-l10 !important;
}
</style>
